module.exports = __webpack_public_path__ + "img/mobile-elbow_54x70.957986c8.png";